import { useUserStore } from "stores/userStore";

const usuario = useUserStore.getState().userState;
const Globales = {
	Url: import.meta.env.PROD
		? import.meta.env.VITE_API_BASE_URL + "/"
		: //  'https://wsdemo.fabricanook.com'
		  //  'https://ws.fabricanook.com/'
		  import.meta.env.VITE_API_BASE_URL + "/",

	token: "Bearer " + usuario.Token || "",
	usuario: usuario,
	KeyConekta: import.meta.env.VITE_CONEKTA_PUBLIC_KEY || "",
};

export default Globales;

// ObjectId("5d2786d4c3184c2aa0d3b42c")
